// import React from "react";
// import IconButton from "./IconButton";
// import Button from "./Button"; // Import the Button component
// import Icon from "../../assets/icons/Icon";
// import { useState } from "react";
// import { useEffect } from "react";
// import Select from "./Select";
// import { isMobileView } from "./CommonFunctions";
// import PopupModal from "./PopupModal";

// const ViewPage = ({
//   name,
//   description,
//   highLightFirstLetter,
//   handleEditBtnClick,
//   handleDeleteBtnClick,
//   handleRemoveBtnClick,
//   children,
//   moreBtn,
//   tabs,
//   customHeader,
//   backgroundColor,
//   iconButtons = []
// }) => {
//    const [showMobileOptions, setShowMobileOptions] = useState(false);


//   // Render icon buttons from the array
//   const renderIconButtons = () => {
//     return iconButtons.map((button, index) => {
//       // If type is "button", render Button component
//       if (button.type === "button") {
//         return (
//           <div key={index} className="flex gap-2">
//             <Button
//               type={button.buttonType || "primary"}
//               iconType={button.iconType}
//               onClick={button.onClick}
//               disabled={button.disabled}
//               className={button.className}
//             >
//               {button.label}
//             </Button>

//             {/* Render select dropdown if button has selectProps */}
//             {button.hasSelect && button.selectProps && (
//               <Select
//                 onChange={button.selectProps.onChange}
//                 value={button.selectProps.value}
//                 options={button.selectProps.options}
//               />
//             )}
//           </div>
//         );
//       }

//       // Otherwise render IconButton (default behavior)
//       return (
//         <div key={index} className="flex  gap-2">
//           <span onClick={button.onClick}>
//             <IconButton
//               bgColor={button.bgColor || "#F5F5F5"}
//               textColor={button.textColor || "#5e5e5e"}
//               newhover={button.newhover !== undefined ? button.newhover : true}
//               infoText={button.label}
//               tooltipWidth={button.tooltipWidth || "100px"}
//             >
//               {button.icon}
//             </IconButton>
//           </span>

//           {/* Render select dropdown if button has selectProps */}
//           {button.hasSelect && button.selectProps && (
//             <Select
//               onChange={button.selectProps.onChange}
//               value={button.selectProps.value}
//               options={button.selectProps.options}
//             />
//           )}
//         </div>
//       );
//     });
//   };

//   console.log("rendericonbuttons",renderIconButtons());

//   return (
//     <div className="flex flex-col relative h-screen pb-7 overflow-hidden bg-white">
//       {/* Header */}
//       <div className="relative flex-shrink-0 bg-cover bg-left pt-[16px] border-b border-solid border-[#eee] px-4">
//         {!customHeader && (
//           <div className={`flex justify-between relative z-10 ${!tabs && "pb-2"}`}>
//             <div className="flex gap-4 items-start">
//                {highLightFirstLetter && <div className="relative">
//                 <div className={`w-14 h-14 rounded-lg flex items-center justify-center text-white text-2xl font-bold shadow-md primary-gradient  capitalize`}>
//                 {highLightFirstLetter}
//                </div>

//                </div>}
//             {name && (
//       <div className="flex flex-col"><h1 className="text-2xl font-bold text-gray-800">
//                  {name}
//               </h1>
//                  {description &&
//         <div className="text-(--tab-gray)">
//           {description}
//               </div>}
//               </div>
//             )}
//             </div>

//             {/* Buttons Container */}
//             <div className="flex gap-5 ">
//               {!isMobileView() && renderIconButtons()}

//               {/* Legacy buttons for backward compatibility */}
//               {handleEditBtnClick && !iconButtons.find(btn => btn.label?.includes("Edit")) && (
//                 <span onClick={handleEditBtnClick}>
//                   <IconButton
//                     bgColor="#F5F5F5"
//                     textColor="#5e5e5e"
//                     newhover={true}
//                   >
//                     <Icon type="edit" />
//                   </IconButton>
//                 </span>
//               )}

//               {moreBtn && <span>{moreBtn}</span>}

//               {handleDeleteBtnClick && !iconButtons.find(btn => btn.label?.includes("Delete")) && (
//                 <span onClick={handleDeleteBtnClick}>
//                   <IconButton
//                     label="help"
//                     bgColor="#F5F5F5"
//                     textColor="#5e5e5e"
//                     newhover={true}
//                   >
//                     <Icon type="delete" />
//                   </IconButton>
//                 </span>
//               )}

//               {handleRemoveBtnClick && !iconButtons.find(btn => btn.label?.includes("Remove")) && (
//                 <span
//                   className="w-7 p-0 text-right text-(--list-item-gray) hover:text-gray-900 cursor-pointer mt-1.5 flex-shrink-0"
//                   onClick={handleRemoveBtnClick}
//                 >
//                   <Icon type={"remove"} />
//                 </span>
//               )}
//             </div>
//           </div>
//         )}
//         {customHeader && <span>{customHeader}</span>}
//         {tabs && <div>{tabs}</div>}
//       </div>

//       {/* Main Content */}
//       <div className="flex-1 flex flex-col overflow-hidden">
//         <div className={`flex-1 overflow-y-auto ${backgroundColor && backgroundColor}`}>
//           {children}
//              {(isMobileView() && iconButtons.length>0) &&
//                <div className="fixed bottom-20 right-6 shadow-lg z-10">
//           <IconButton
//            onClick={() => {
//                 setShowMobileOptions(true);
//                 console.log("Floating button clicked");
//               }}
//           type="primary">
//  <Icon type="option" />
//           </IconButton>
//           </div>
//           }
//         </div>
//       </div>
//     {showMobileOptions && (
//   <PopupModal
//     setPopUp={setShowMobileOptions}
//     size="w-[90%] max:h-[70%]"
//     title="options"
//   >
//     {iconButtons.map((button) => {
//       return (
//         <div key={button.label} className="my-2">
//           {button.type=="button" ?
//               <Button type={button?.buttonType ||"secondary"} onClick={()=>{button?.onClick(),setShowMobileOptions(false)}} showFullWidth={true}>
//              {button?.iconType && (
//             <span className="w-5 mr-[4px]">
//              <Icon type={button?.iconType}/>
//             </span>
//           )}  {button?.label}
//           </Button> :
//              <Button type="secondary" onClick={()=>{button?.onClick(),setShowMobileOptions(false)}} showFullWidth={true}>
//              {button?.icon && (
//             <span className="w-5 mr-[4px]">
//              {button?.icon}
//             </span>
//           )}  {button?.label}
//           </Button>

//           }

//         </div>
//       );
//     })}
//   </PopupModal>
// )}
//     </div>

//   );
// };

// export default ViewPage;

import React, { useRef } from "react";
import IconButton from "./IconButton";
import Button from "./Button";
import Icon from "../../assets/icons/Icon";
import { useState, useEffect } from "react";
import Select from "./Select";
import { isMobileView } from "./CommonFunctions";
import PopupModal from "./PopupModal";

const ViewPage = ({
  name,
  description,
  highLightFirstLetter,
  handleEditBtnClick,
  handleDeleteBtnClick,
  handleRemoveBtnClick,
  children,
  moreBtn,
  tabs,
  customHeader,
  backgroundColor,
  iconButtons = []
}) => {
  const [showMobileOptions, setShowMobileOptions] = useState(false);
  const floatingMenuRef = useRef(null);

  // Render icon buttons from the array
  const renderIconButtons = () => {
    return iconButtons.map((button, index) => {
      // If type is "button", render Button component
      if (button.type === "button") {
        return (
          <div key={index} className="flex gap-2">
            <Button
              type={button.buttonType || "primary"}
              iconType={button.iconType}
              onClick={button.onClick}
              disabled={button.disabled}
              className={button.className}
            >
              {button.label}
            </Button>

            {/* Render select dropdown if button has selectProps */}
            {button.hasSelect && button.selectProps && (
              <Select
                onChange={button.selectProps.onChange}
                value={button.selectProps.value}
                options={button.selectProps.options}
              />
            )}
          </div>
        );
      }

      // Otherwise render IconButton (default behavior)
      return (
        <div key={index} className="flex gap-2">
          <span onClick={button.onClick}>
            <IconButton
              bgColor={button.bgColor || "#F5F5F5"}
              textColor={button.textColor || "#5e5e5e"}
              newhover={button.newhover !== undefined ? button.newhover : true}
              infoText={button.label}
              tooltipWidth={button.tooltipWidth || "100px"}
            >
              {button.icon}
            </IconButton>
          </span>

          {/* Render select dropdown if button has selectProps */}
          {button.hasSelect && button.selectProps && (
            <Select
              onChange={button.selectProps.onChange}
              value={button.selectProps.value}
              options={button.selectProps.options}
            />
          )}
        </div>
      );
    });
  };

  // Combined click outside handler
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Close floating menu when clicking outside
      if (floatingMenuRef.current && !floatingMenuRef.current.contains(event.target)) {
        setShowMobileOptions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Floating menu items component
  const FloatingMenuItems = () => {
    return (
      <div className="flex flex-col">
        {iconButtons.map((button, index) => {
          // Define colors based on button type or index
          const getButtonColors = () => {
            // You can customize these colors based on button properties
            const colors = [
              { bg: "#ef4444", text: "#ffffff" }, // Red
              { bg: "#8b5cf6", text: "#ffffff" }, // Purple
              { bg: "#10b981", text: "#ffffff" }, // Green
              { bg: "#f59e0b", text: "#ffffff" }, // Amber
              { bg: "#3b82f6", text: "#ffffff" }, // Blue
              { bg: "#6366f1", text: "#ffffff" }, // Indigo
              { bg: "#ec4899", text: "#ffffff" }, // Pink
              { bg: "#14b8a6", text: "#ffffff" }, // Teal
            ];

            // You can also set colors based on button.label or button.type
            if (button.label?.toLowerCase().includes('delete') ||
              button.label?.toLowerCase().includes('remove')) {
              return { bg: "#dc2626", text: "#ffffff" }; // Dark red for delete/remove
            }
            if (button.label?.toLowerCase().includes('save')) {
              return { bg: "#10b981", text: "#ffffff" }; // Green for save
            }
            if (button.label?.toLowerCase().includes('cancel')) {
              return { bg: "#6b7280", text: "#ffffff" }; // Gray for cancel
            }

            // Return color based on index or default
            return colors[index % colors.length];
          };

          const colors = getButtonColors();
          console.log("button", button);
          return (
            <div
              key={button.label || index}
              className="w-full flex justify-end items-center px-4 py-3 hover:bg-gray-50 cursor-pointer group gap-4"
              onClick={() => {
                button?.onClick?.();
                setShowMobileOptions(false);
              }}
            >
              <span
                className="font-semibold text-right whitespace-nowrap"
                style={{ color: colors.text }}
              >
                {button.label}
              </span>
              <div className="relative flex-shrink-0">
                <IconButton
                  bordernone={true}
                  bgColor={colors?.bg || "#8b5cf6"}
                  textColor={colors?.text || "#ffffff"}
                  isHoverColor={true}
                >
                  {button.icon}
                </IconButton>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="flex flex-col relative h-screen pb-7 overflow-hidden bg-white">
      {/* Header */}
      <div className={`relative flex-shrink-0 bg-cover  bg-left  border-b border-solid border-[#eee]  `}>
        {!customHeader && (
          <div className={`${isMobileView() ? "primary-gradient py-3" :"pt-[16px]"}  px-4 flex justify-between text-white items-start relative z-10 ${!tabs && "pb-2"}`}>
            {/* Left side: Back icon + avatar + title/description */}
            <div className={`flex gap-4 ${isMobileView() ?  "items-center" :"items.-start"}`}>
              {/* Back icon - mobile only */}
              {(handleRemoveBtnClick && isMobileView()) &&
                !iconButtons.find(btn => btn.label?.includes("Remove")) && (
                  <span
                    className={`w-7 h-7 flex items-center justify-center ${!isMobileView() && "text-(--list-item-gray)"} hover:text-gray-900 cursor-pointer flex-shrink-0`}
                    onClick={handleRemoveBtnClick}
                  >
                    <Icon type="back" />
                  </span>
                )}

              {/* Highlight first letter avatar */}
              {highLightFirstLetter && (
                <div className="relative">
                  <div className="w-14 h-14 rounded-lg flex items-center justify-center text-white text-2xl font-bold shadow-md primary-gradient capitalize">
                    {highLightFirstLetter}
                  </div>
                </div>
              )}

              {/* Name & description */}
              {name && (
                <div className="flex flex-col justify-center">
                  {isMobileView() &&  <h2 className="text-xl truncate max-w-[300px] font-bold">{name}</h2>}
                  {!isMobileView() &&<h1
                    className={`text-2xl font-bold   text-gray-800
                      }`}
                  >
                    {name}</h1>}
                  {description && (
                    <div className="text-(--tab-gray)">
                      {description}
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Right side buttons */}
            <div className="flex gap-5 items-center">
              {!isMobileView() && renderIconButtons()}

              {handleEditBtnClick && !iconButtons.find(btn => btn.label?.includes("Edit")) && (
                <span onClick={handleEditBtnClick}>
                  <IconButton
                    bgColor="#F5F5F5"
                    textColor="#5e5e5e"
                    newhover={true}
                  >
                    <Icon type="edit" />
                  </IconButton>
                </span>
              )}

              {moreBtn && <span>{moreBtn}</span>}

              {handleDeleteBtnClick && !iconButtons.find(btn => btn.label?.includes("Delete")) && (
                <span onClick={handleDeleteBtnClick}>
                  <IconButton
                    bgColor="#F5F5F5"
                    textColor="#5e5e5e"
                    newhover={true}
                  >
                    <Icon type="delete" />
                  </IconButton>
                </span>
              )}

              {/* Remove button - desktop only */}
              {(handleRemoveBtnClick && !isMobileView()) && !iconButtons.find(btn => btn.label?.includes("Remove")) && (
                <span
                  className="w-7 h-7 flex items-center justify-center text-(--list-item-gray) hover:text-gray-900 cursor-pointer flex-shrink-0"
                  onClick={handleRemoveBtnClick}
                >
                  <Icon type="remove" />
                </span>
              )}
            </div>
          </div>
        )}
        {customHeader && <span className="px-4">{customHeader}</span>}
        {tabs && <div className="px-4">{tabs}</div>}
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <div className={`flex-1 overflow-y-auto ${backgroundColor || ''}`}>
          {children}
        </div>
      </div>

      {/* Mobile options menu */}
      {(isMobileView() && iconButtons.length > 0) && (
        <>
          {/* Overlay */}
          {showMobileOptions && (
            <div
              className="fixed inset-0 bg-black/70 z-10"
              onClick={() => setShowMobileOptions(false)}
            />
          )}

          <div className="fixed bottom-5 right-6 z-20" ref={floatingMenuRef}>
            {/* Floating Menu Items */}
            {showMobileOptions && (
              <div className="absolute bottom-16 right-0 mb-2 overflow-hidden animate-slide-up">
                <div className="py-2 shadow-xl">
                  <FloatingMenuItems />
                </div>
              </div>
            )}

            {/* Main Floating Button */}
            <IconButton
              size="large"
              onClick={() => {
                setShowMobileOptions(!showMobileOptions);
              }}
              bordernone={true}
              type="primary"
            >
              <span className="text-white">
                <Icon type={showMobileOptions ? "remove" : "option"} />
              </span>
            </IconButton>
          </div>
        </>
      )}
    </div>
  );
};

export default ViewPage;